import React from 'react';

import ReduxConnect from 'Demora/redux-connect';

import headerText from './headerText';

class ProfileFirstBlock extends React.Component {
	render() {
		let obj = this.props.obj;

		let h = headerText(obj);

		let signup = new URLSearchParams(window.location.search.substring(1)).get(
			'showSignup'
		);

		let referral_link;

		let rlu = this.props.users[window.location.pathname.split('/').pop()];

		if (rlu) {
			referral_link = '/r/' + rlu.username;
		}

		return (
			<div>
				{h && (
					<div className='d-sm-none row mt-2 animated fadeIn'>
						<div className='col-12'>
							<div className='card panel-white well-social-post post panel-shadow mb-2'>
								<ul className='list-inline m-0' id='list_PostActions'>
									<li className='list-inline-item active'>
										<i className='fa fa-user'></i>
										&nbsp;
										<span>About</span>
									</li>
								</ul>
								<span className='text-muted pl-2 pr-2'>{h}</span>
							</div>
						</div>
					</div>
				)}

				{!this.props.user.id && signup && referral_link && (
					<div className='text-primary text-center mt-3 mb-3'>
						<a href={referral_link} className='btn btn-danger'>
							<h3>Click here to join me at CashJuice</h3>
						</a>
					</div>
				)}
			</div>
		);
	}
}

export default ReduxConnect(ProfileFirstBlock, {
	user: 'user',
	users: 'users',
});
